// FilterValues.js

import React from 'react';
import { Skeleton, Slider, Input, Switch } from 'antd';
import FilterPill from "./FilterPill";

const FilterValues = ({ type, values, selectedValues, onSelectionChange, loading }) => {
    const handleFilterClick = (value) => {
        if (selectedValues.includes(value)) {
            onSelectionChange(selectedValues.filter(v => v !== value));
        } else {
            onSelectionChange([...selectedValues, value]);
        }
    };

    return (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
            {values.map((value) => (
                <FilterPill
                    key={value.value}
                    label={value.label}
                    count={value.count}
                    active={selectedValues.includes(value.value)}
                    onClick={() => handleFilterClick(value.value)}
                />
            ))}
        </div>
    );
};

export default FilterValues;
